var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData)?_c('DoughnutChartGenerator',{attrs:{"chart-options":_vm.getChartOptions(),"chart-data":_vm.chartData,"plugins":_vm.plugins,"css-classes":_vm.cssClasses,"styles":_vm.styles,"width":_vm.width,"height":_vm.height}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }